export const phoneRecords = {
  //  Common
  title: 'Phone Records',
  subtitle: 'View all call records and detailed information',
  
  //  Tabs
  outboundTab: 'Outbound Records',
  inboundTab: 'Inbound Records',
  
  //  Outbound Page
  outboundTitle: 'Outbound Records',
  outboundSubtitle: 'AI outbound call records',
  outboundPhoneLabel: 'AI Outbound Phone Number',
  
  //  Inbound Page
  inboundTitle: 'Inbound Records',
  inboundSubtitle: 'AI inbound call records',
  inboundPhoneLabel: 'Inbound Phone Number',
  
  //  Table Columns
  taskName: 'Task Name',
  phoneNumber: 'Phone Number',
  callerNumber: 'Caller Number',
  callTime: 'Call Time',
  incomingTime: 'Incoming Time',
  result: 'Result',
  status: 'Status',
  duration: 'Duration',
  summary: 'Summary',
  keywordSummary: 'Keyword Summary',
  viewDetails: 'View Details',
  
  //  Status
  statusSuccess: 'Success',
  statusFailed: 'Failed',
  statusNoAnswer: 'No Answer',
  statusConnected: 'Connected',
  
  //  Filters
  filterByDate: 'Date Range',
  filterByTask: 'Task Name',
  filterByStatus: 'Status',
  allStatus: 'All Status',
  search: 'Search',
  reset: 'Reset',
  
  //  Detail Modal
  detailTitle: 'Call Details',
  basicInfo: 'Basic Information',
  callSummary: 'Call Summary',
  keywordTags: 'Keyword Tags',
  downloadRecording: 'Download Recording',
  viewTranscript: 'View Transcript',
  close: 'Close',
  
  //  Empty State
  noRecords: 'No call records',
  noRecordsHint: 'Call records will appear here when available',
  recording: 'Call Recording',
  playRecording: 'Play Recording',
  pauseRecording: 'Pause',
};
